<template>
  <div>
    <button
      class="btn btn-menu d-lg-none"
      @click.stop="clickMenuButton"
      @mouseenter="clickMenuButton"
    >
      <i class="icon-menu menu d-none d-lg-block"></i>
      <i class="menu d-lg-none" :class="showMenu ? 'icon-x' : 'icon-menu'"></i>
    </button>

    <aside
      class="overflow-y-scroll"
      :class="{ open: showMenu }"
      @mouseenter="openMenu"
      @mouseleave="closeMenu"
    >
      <div
        class="aside-content d-flex flex-column align-items-start text-white"
      >
        <component
          v-if="contextSideBar"
          :is="contextSideBar.component"
          @back="showRootMenu = true"
          @closeMenu="closeMenu"
          :openContext="openContext"
          @toggleContext="toggleContext"
          :indicatorClasses="indicatorClasses(contextSideBar.url_match)"
          :showMenu="showMenu"
        />

        <div v-else class="w-100">
          <div v-for="(option, i) in options" :key="i">
            <template v-if="showOption(option)">
              <template v-if="option.custom">
                <!-- Programa de indicações -->
                <template v-if="option.name == 'Indique & Ganhe'">
                  <button
                    v-if="!hasReferUrl"
                    class="btn"
                    @click="recommendationTerms = true"
                  >
                    <i class="fa-light fa-bullhorn" />
                    <span>Indique & Ganhe</span>
                  </button>
                  <router-link
                    v-else
                    :to="{ name: 'recommendation-program' }"
                    class="btn home"
                    @click.native="closeMenu"
                  >
                    <i class="fa-light fa-bullhorn" />
                    <span>Indique & Ganhe</span>
                  </router-link>
                </template>
                <!-- Programa de indicações -->
              </template>

              <router-link
                v-else-if="option.route"
                class="btn home"
                :to="option.route"
                :class="indicatorClasses(option.indicator)"
                @click.native="closeMenu"
              >
                <i :class="option.icon" />
                <span>{{ option.name }}</span>
              </router-link>

              <template v-else-if="option.context">
                <button
                  class="btn"
                  :class="indicatorClasses(option.indicator)"
                  @click="toggleContext(option.context)"
                >
                  <i :class="option.icon" />
                  <span>{{ option.name }}</span>
                  <i
                    class="icon-angle-right"
                    :class="{
                      'rotate-90-clock': openContext == option.context
                    }"
                  />
                </button>

                <div
                  v-if="showMenu && openContext == option.context"
                  class="pl-5"
                >
                  <div v-for="(opt, index) in option.options" :key="index">
                    <router-link
                      v-if="showOption(opt)"
                      class="btn context-option"
                      :to="opt.route"
                      @click.native="closeMenu"
                    >
                      <span>{{ opt.name }}</span>
                    </router-link>
                  </div>
                </div>
              </template>
            </template>
          </div>
        </div>

        <div class="flex-fill" />
        <div class="pl-5">
          <whatsapp-button class="d-none d-lg-flex pl-2" size="large" />
        </div>
        <button class="btn" @click="openFaq">
          <i class="fa-light fa-circle-info"></i>
          <span>FAQ</span>
        </button>
      </div>
    </aside>

    <recommendation-modal v-model="recommendationTerms" />
  </div>
</template>

<script>
import RecommendationModal from "@/components/recommendation/RecommendationModal";
import { MENU_OPTIONS } from "@/constants/sideMenu";
import WhatsappButton from "./WhatsappButton.vue";
export default {
  components: { RecommendationModal, WhatsappButton },
  data() {
    return {
      showMenu: false,
      logoutDialog: false,
      recommendationTerms: false,
      menuButtonTimeout: null,
      showRootMenu: false,
      openContext: "",
      options: MENU_OPTIONS
    };
  },
  computed: {
    contextSideBar() {
      if (this.showRootMenu || !this.$route.meta.sidemenu) return false;
      return this.$route.meta.sidemenu;
    },
    hasReferUrl() {
      return !!this.$user.user?.refer_url;
    }
  },
  methods: {
    indicatorClasses(context) {
      if (
        context &&
        this.$router.currentRoute.path.match(context) &&
        !this.showMenu
      ) {
        return "active-item-indiciator";
      }
      return "";
    },
    showOption(option) {
      if (!option.permissions || !option.permissions.length) return true;

      return !!option.permissions.find(this.$permissions.hasPermission);
    },

    toggleContext(context) {
      if (this.openContext === context) {
        this.openContext = null;
      } else {
        this.openContext = context;
      }
    },
    setMenu(value, timeout) {
      if (this.menuButtonTimeout) {
        clearTimeout(this.menuButtonTimeout);
      }
      this.menuButtonTimeout = setTimeout(() => {
        this.showMenu = value;
      }, timeout);
    },
    openMenu() {
      this.setMenu(true, 100);
    },
    closeMenu() {
      this.setMenu(false, 100);
    },
    clickMenuButton() {
      this.setMenu(!this.showMenu, 10);
    },

    openFaq() {
      window.open("https://ajuda.blitzpay.com.br/", "_blank");
    }
  },
  watch: {
    $route() {
      this.showRootMenu = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-menu {
  position: fixed;
  width: 48px;
  top: 0;
  z-index: 4;
  & > * {
    @media screen and (max-width: 991px) {
      color: #3d3d3d !important;
      font-size: 24px !important;
    }
  }
}
aside {
  position: fixed;
  z-index: 30;
  left: 0;
  top: 72px;
  bottom: 0;
  width: 72px;
  display: flex;
  flex-direction: column;
  transition: all 0.1s;
  .brand {
    padding-left: 26px;
  }
  @media screen and (max-width: 991px) {
    width: 0px;
    top: 0px;
  }
  .aside-content {
    flex: 1 1 auto;
    background: #fff;
    transition: width 0.15s;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.2);

    @media screen and (max-width: 991px) {
      padding-top: 50px;
    }
    ::v-deep.btn {
      border-radius: 0px;
      width: 100%;
      color: #584c68;
      display: flex;
      cursor: pointer;
      padding-top: 12px;
      padding-bottom: 12px;
      justify-content: flex-start;
      font-weight: 400;
      i {
        color: #85759b;
      }
      &.router-link-active:not(.home):not(.context-option),
      &.router-link-exact-active {
        color: #310071;
        font-weight: bold;
        border-radius: 0;
        background: rgba(255, 255, 255, 0.05);
        i {
          color: #310071;
        }
        @media screen and (min-width: 576px) {
          padding-left: 13px;
          border-right: 4px solid #310071;
        }
        @media screen and (max-width: 575px) {
          padding-left: 9px;
          border-right: 4px solid #310071;
        }
      }
      span {
        margin-left: 12px;
        white-space: nowrap;
        flex: 1 1 auto;
        text-align: left;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      &:hover {
        color: #310071;
        i {
          color: #310071;
        }
        .news {
          i {
            font-size: 0;
            min-width: 0;
            width: 0px;
            opacity: 0;
          }
          span {
            font-size: 14px;
            opacity: 1;
          }
        }
      }
    }
    .active-item-indiciator {
      font-weight: bold;
      border-right: 4px solid #310071;
      background: rgba(255, 255, 255, 0.05);
      @media screen and (max-width: 575px) {
        padding-left: 9px;
      }
      i {
        color: #310071;
      }
    }
    .news {
      opacity: 0;
      padding: 4px;
      height: 30px;
      display: flex;
      border-radius: 8px;
      align-items: center;
      background: #423d4d;
      transition: 0.1s opacity;
      border: 1px solid rgba(230, 213, 255, 0.85);
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
      span,
      i {
        margin: 0;
        transition: all 0.3s;
        color: rgba(230, 213, 255, 0.85) !important;
      }
      i {
        min-width: 24px;
      }
      span {
        opacity: 0;
        font-size: 0;
      }
    }
  }
  &.open {
    width: 343px;
    padding-right: 20px;

    .news {
      opacity: 1;
    }
  }
  &:not(.open) {
    border-right: 1px solid #dbd6e1;
    .btn:has(.news) {
      i::after {
        content: "";
        top: 9px;
        right: 9px;
        width: 10px;
        aspect-ratio: 1;
        border-radius: 50%;
        position: absolute;
        background: rgba(230, 213, 255, 0.85);
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
      }
      &.active-item-indiciator,
      &.router-link-exact-active {
        i::after {
          right: 5px;
        }
      }
    }
  }
}
i {
  font-size: 20px;
  min-width: 46px;
  transition: all 0.2s;
  &.menu {
    font-size: 32px;
    line-height: 44px;
    color: rgba(51, 51, 51, 0.6);
  }
}
.open-submenu {
  .icon-angle-right {
    transform: rotate(90deg);
  }
}
.submenu {
  width: 100%;
  a {
    padding-left: 32px !important;
  }
}
</style>
